import type { VoidFunctionComponent } from 'react';
import cx from 'classnames';
import styles from './StateContextPanel.module.less';

const UnknownStatePanel: VoidFunctionComponent = () => (
  <div className={cx(styles.stateContextPanel, styles.buildState)}>
    FOSSA was unable to analyze this dependency.
    If it is behind a private registry or auth you may need to configure FOSSA&apos;s access,
    then rebuild this dependency.
  </div>
);

export default UnknownStatePanel;
